module.exports = __webpack_public_path__ + "img/top-right-bg.b79ec6b1.png";